import { GenericInjection } from "./GenericInjection";
import { Injection } from "./Injection";

export class Attachment implements Injection {
  /**
   * Creates an Attachment object if the editor is a valid attachment, null if it's not valid.
   *
   * @param editor The HTML element of a potential editor
   * @param origin the origin of the element's page
   * @returns an Attachment if the element can be attached, null otherwise.
   */
  static tryAttach(
    editor: HTMLElement,
    document: HTMLDocument,
    origin: string
  ): Attachment | null {
    const a = new Attachment(editor, document, origin);
    if (a.shouldAttach()) {
      return a;
    }
    return null;
  }

  private injectionStrategy: Injection | undefined;

  private constructor(
    readonly editor: HTMLElement,
    readonly document: HTMLDocument,
    readonly origin: string
  ) {
    this.injectionStrategy = new GenericInjection(this.document);
  }

  private getInjection(): Injection {
    if (!this.injectionStrategy) {
      this.injectionStrategy = new GenericInjection(this.document);
    }
    return this.injectionStrategy;
  }

  injectUnderlineRoot(onCreate?: (div: HTMLDivElement) => void): HTMLElement {
    return this.getInjection().injectUnderlineRoot(onCreate);
  }
  injectDotRoot(onCreate?: (div: HTMLDivElement) => void): HTMLElement {
    return this.getInjection().injectDotRoot(onCreate);
  }

  public static possibleEditors(): Element[] {
    const contentEditables = document.querySelectorAll(
      'div[contenteditable="true"]'
    );
    const textareas = document.querySelectorAll("textarea");
    return [...Array.from(contentEditables), ...Array.from(textareas)];
  }

  public isGenericContentEditable(): boolean {
    return this.editor.contentEditable === "true" && this.editor.spellcheck;
  }

  private shouldAttach(): boolean {
    return true;
  }
}
